import Container from "react-bootstrap/esm/Container";
import F404 from "../../assets/404.png";

export function Error404() {
    const handleReturn = () => {
        window.location.href = '/'; // Redirige a la página principal
      };

  return (
    <section className="d-flex align-items-center justify-content-center min-vh-100">
      <Container className="container__error text-center">
        <div className="section_container mb-4">
          <h2 className="section__title--error">
            This page has decided to take a break, let's go back to the
            beginning!
          </h2>
        </div>
        <div className="section_container mb-4">
          <img src={F404} alt="fallo de programa" className="img-fluid" />
        </div>
        <button onClick={handleReturn} className='form__button'>
          Return
        </button>
      </Container>
    </section>
  );
}

export default Error404;
